import 'css-chunksrc/client/pages/eventPage/details/nameForm/styles.scss';export default {
  "input": "_input_16n3s_1",
  "invalid": "_invalid_16n3s_16"
};